import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,Label } from 'reactstrap';
import { Route, BrowserRouter,NavLink,Switch} from 'react-router-dom';
import createHistory from "history/createBrowserHistory";
import {rescheduleReasonAction} from '../../../actions/index';
import api from '../../../utility/api/api.js';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
class Reschedule extends React.Component{
constructor(props) {
  super(props);
  this.state={modal: false};
  this.masterData=JSON.parse(localStorage.getItem('getMasterData'));
  this.toggle = this.toggle.bind(this);
  const history = createHistory();
  const unlisten = history.listen((location, action) => {
      if(this.state.modal){
        this.setState({modal:false});
      }
  })
}
componentWillReceiveProps(nextProps){
    // console.log("!!!resched",nextProps)
}
componentWillMount() {
    api.getRescheduleReason(this);
    
   }

toggle(data,e) {
if(data==='Reshedule'){
    if(document.querySelector("input[name='resheduleorder']:checked")) {
        let riderId = localStorage.getItem('rider_id');
        let reason=document.querySelector("input[name='resheduleorder']:checked").value;
        api.resheduleApi(this.props.order_id,reason);
    }else{
        this.setState({error:'Please Select the field'});
        e.preventDefault();
        return;
    }
    }
    this.setState({
    modal: !this.state.modal,error:''
});
}

render() {
if(this.props && this.props.rescheduleData) {
return (
<div>
    <BrowserRouter>
    <div>
  
     {
         (!this.props.notifyDisable) ?
         <NavLink onClick={this.toggle} to='/intransit/resheduleorder' className='spn-jobs-decisionbutton btn spn-jobs-decisionbutton-cancel orange-btn'  >Reschedule</NavLink>
         :
         <button className="rescheduleDisable" disabled>Reschedule</button>
     }   
    
    <Switch>
    <Route path='/intransit/resheduleorder'>
    <Modal isOpen={this.state.modal} backdrop={'static'} keyboard={false} fade={false} toggle={this.toggle} className={this.props.className}>
    <ModalHeader className='justify-content-center py-2 alert-secondary'>Reason to {this.props.label}</ModalHeader>
    <ModalBody>
        <div className='select-reason-title'>SELECT REASON</div>
        {this.props && this.props.rescheduleData && this.props.rescheduleData[0].data.reasons.map((obj,key)=>(
            <div key={key}>
                    <div><input className='with-gap custom-check' onChange={e=>this.setState({error:''})} value={obj.reason} id={`delay_${key}`} name='resheduleorder' type='radio'/><Label htmlFor={`delay_${key}`}>{obj.reason}</Label></div>
            </div>
        ))}
        <div className="text-danger">{this.state.error}</div>
    </ModalBody>
    <ModalFooter className='p-0 border-0'>
        <span className='col-6 text-center'><NavLink to='/intransit'><button className='btn bg-white m-0 py-2'  onClick={this.toggle}>Cancel</button></NavLink></span>
        <span className='col-6 text-center'><NavLink className='btn m-0 py-2' exact to="/intransit" onClick={e=>this.toggle(this.props.label,e)}>OK, Done</NavLink></span>{' '}

    </ModalFooter>
    </Modal>
</Route>
</Switch>
</div>
</BrowserRouter>
</div>
);
}
else {
return (
<div>
    <Button  onClick={this.toggle}>{this.props.label}</Button>
</div>
);
}
}
}
function mapStateToProps(state){
    console.log("rescheduleDetails",state);
  return {
    rescheduleData:state.reschedulereason
    
  };
  }
  function mapDispatchToProps(dispatch){
      return bindActionCreators({rescheduleReasonAction:rescheduleReasonAction},dispatch);
  }
  export default connect(mapStateToProps,mapDispatchToProps)(Reschedule);




// WEBPACK FOOTER //
// ./src/components/Intransit/ViewTripList/Reschedule.js